export function canReparentSection(sections, sectionId, parentId) {
  const source = sections.find((section) => String(section.id) === String(sectionId));
  if (!source || String(source.parentSectionId ?? '') === String(parentId ?? '')) return false;
  const visited = new Set([String(sectionId)]);
  let current = parentId;
  while (current != null) {
    if (visited.has(String(current))) return false;
    visited.add(String(current));
    let parent = null;
    for (const section of sections) {
      if (String(section.id) === String(current)) {
        parent = section;
        break;
      }
    }
    if (!parent) return false;
    current = parent.parentSectionId;
  }
  return true;
}
